export default __webpack_public_path__ + "static/LP5-1f3ceb6f98ded8b8338bc5a10a0e08eb.png";